import { getEnvVar } from '../envUtils.ts';
import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
 url: getEnvVar('REACT_APP_KEYCLOAK_URL'),
 realm: getEnvVar('REACT_APP_KEYCLOAK_REALM'),
 clientId: "ATMOS-UI-CLIENT",
});

export default keycloak;
